/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Button, ToastNotification, Link } from 'carbon-components-react';
import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { DialogNotificationMessages as messages } from './messages';

interface DialogNotificationProps {
  routeToAssistantSettings: () => void;
  dontRemindMeClick: () => void;
  className: string;
}

export const DialogNotification = ({
  routeToAssistantSettings,
  dontRemindMeClick,
  className
}: DialogNotificationProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <ToastNotification
      className={className}
      title={t(messages.notificationTitile)}
      statusIconDescription="warning"
      subtitle={t(messages.notificationSubtitile, {
        a: chunk => (
          <Link
            className="WebPreview__notification-link"
            onClick={routeToAssistantSettings}>
            {chunk}
          </Link>
        )
      })}
      kind="warning"
      lowContrast
      children={
        <>
          <Button
            className="WebPreview__notification-btn"
            kind="tertiary"
            onClick={dontRemindMeClick}>
            <FormattedMessage {...messages.dontRemindMe} />
          </Button>
        </>
      }
    />
  );
};
